import { WrapperDate } from './styles';

const Author = ({ date }) => {
  const _date = new Date(date).toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
      
  });

  return (
    <WrapperDate>
      <span className="description">{_date}</span>
    </WrapperDate>
  );
};

export default Author;
